{{showDescription ? (permissionTranslationCode|translate|firstUpper) : ''}}<app-tooltip *ngIf="tooltip || tooltipImage" [value]="tooltip" [image]="tooltipImage"></app-tooltip>
